import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { cruiseCompanies } from './cruiseCompanies.js';
import { Background } from './cruiseLogo.style.js';
import { jsx } from 'react/jsx-runtime';
import useIsGlobetrotter from '../../hooks/useIsGlobetrotter.js';

var _excluded = ["cruiseCode", "alt", "responsive", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CruiseLogo = function CruiseLogo(_ref) {
  var _cruiseCompanies$crui, _cruiseCompanies$crui2, _cruiseCompanies$crui3;
  var _ref$cruiseCode = _ref.cruiseCode,
    cruiseCode = _ref$cruiseCode === void 0 ? null : _ref$cruiseCode,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? null : _ref$alt,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isGlobetrotter = useIsGlobetrotter();
  if (!cruiseCode) {
    return false;
  }
  var src = isGlobetrotter ? (_cruiseCompanies$crui = cruiseCompanies[cruiseCode]) === null || _cruiseCompanies$crui === void 0 ? void 0 : _cruiseCompanies$crui.globetrotterUrl : (_cruiseCompanies$crui2 = cruiseCompanies[cruiseCode]) === null || _cruiseCompanies$crui2 === void 0 ? void 0 : _cruiseCompanies$crui2.url;
  if (!src) {
    return null;
  }
  return /*#__PURE__*/jsx(Background, _objectSpread(_objectSpread({
    $responsive: responsive,
    $size: size
  }, rest), {}, {
    children: /*#__PURE__*/jsx("img", {
      src: src,
      alt: alt || ((_cruiseCompanies$crui3 = cruiseCompanies[cruiseCode]) === null || _cruiseCompanies$crui3 === void 0 ? void 0 : _cruiseCompanies$crui3.name)
    })
  }));
};
var CruiseLogo$1 = CruiseLogo;

export { CruiseLogo$1 as default };
//# sourceMappingURL=CruiseLogo.js.map
